import { request } from "../network/request";
const db = "dn0";
//查询任务类型列表
export function getTaskTypeList(params) {
  return request({
    url: "pmp/taskType/taskTypeList",
    method: "get",
    params: {
      db,
      ...params,
    },
  });
}

export function deleteTasktype(id) {
  return request({
    url: 'pmp/taskType/deleteTaskType',
    method: 'get',
    params: { id: id },
  })
}

export function getKeyValue(stringType,bmbh, status) {
  return request({
    url: 'pmp/taskType/getKeyValue',
    method: 'get',
    params: { db, stringType,bmbh, status },
  })
}


export function getBmxxList( status) {
  return request({
    url: "pmp/taskType/getBmxxList",
    method: "get",
    params: {
      db,
      status,
    },
  });
}

export function getTasklxList(bmbh,txlx) {
  return request({
    url: "pmp/taskType/getTasklxList",
    method: "get",
    params: {
      db,
      bmbh,
      txlx,
    },
  });
}
export function getTaskZlList(name, bmbh, txlx) {
  return request({
    url: "pmp/taskType/getTaskZlList",
    method: "get",
    params: {
      db,
      name,
      bmbh,
      txlx,
    },
  });
}
/**
 * 新增任务类型
 * @param {*} params 
 * @returns 
 */
export function saveAddTaskType(params) {
  return request({
    url: "pmp/taskType/saveTaskType",
    method: "post",
    data: params,
  });
}

export function saveEditTaskType(params) {
  return request({
    url: "pmp/taskType/updateTaskType",
    method: "post",
    data: params,
  });
}


/**
 * 任务类型回显
 * @param {*} params 
 * @returns 
 */
export function getTaskType(params) {
  return request({
    url: "pmp/taskType/getTaskType",
    method: "get",
    params,
  });
}


